export const VendorsConstants = {
    GET_VENDORS: 'GET_VENDORS',

    GETALL_VENDORS_REQUEST: 'GETALL_VENDORS_REQUEST',
    GETALL_VENDORS_SUCCESS: 'GETALL_VENDORS_SUCCESS',
    GETALL_VENDORS_FAILURE: 'GETALL_VENDORS_FAILURE',
    RESET_VENDORS: 'RESET_VENDORS'
};
